module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "praise"
  }, [_c('a', {
    attrs: {
      "id": "praise"
    }
  }), _c('a', {
    attrs: {
      "id": "pag_i"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Praise for Jennifer Estep’s thrilling Elemental Assassin series")])])]), _c('a', {
    attrs: {
      "id": "pag_i"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Watch out, world, here comes Gin Blanco. Funny, smart, and dead sexy.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—Lilith Saintcrow, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New York Times")]), _vm._v(" bestselling author")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A raw, gritty, and compelling walk on the wild side.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—Nalini Singh, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New York Times")]), _vm._v(" bestselling author")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“This series kicked off with a bang, and the action hasn’t let up since.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Fresh Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Gin Blanco is one of the most intriguing heroines on the scene.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("RT Book Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“One of the best urban fantasy series going on the market.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Bibliopunkk")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Jennifer Estep is a dark, lyrical, and fresh voice in urban fantasy. . . . Gin is an assassin to die for.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—Adrian Phoenix, author of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("On Midnight Wings")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Man, I love this series.”")]), _vm._v(" "), _c('p', {
    staticClass: "attb"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Yummy Men & Kick Ass Chicks")])]), _vm._v(" "), _c('p', {
    staticClass: "praisea"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("DEADLY STING")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Classic Estep with breathtaking thrills, coolly executed fights, and a punch of humor, which all add up to unbeatable entertainment!”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" (Top Pick!)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“This book is brimming with suspense and fast-paced action. The pacing and plotting are absolute perfection! There’s never a dull moment!”")]), _vm._v(" "), _c('p', {
    staticClass: "attb"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Under the Covers Book Blog")])]), _vm._v(" "), _c('p', {
    staticClass: "praisea"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("WIDOW’S WEB")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pag_i"
    }
  }), _c('a', {
    attrs: {
      "id": "pag_ii"
    }
  }, [_vm._v("“Estep has found the perfect recipe for combining kick-butt action and high-stakes danger with emotional resonance.”")])]), _c('a', {
    attrs: {
      "id": "pag_ii"
    }
  }, [_c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" (Top Pick!)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Filled with such emotional and physical intensity that it leaves you happily exhausted by the end.”")]), _vm._v(" "), _c('p', {
    staticClass: "attb"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("All Things Urban Fantasy")])]), _vm._v(" "), _c('p', {
    staticClass: "praisea"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("BY A THREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "praisec"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Goodreads nominee for Best Paranormal Fantasy Novel and")]), _vm._v(" "), _c('span', {
    staticClass: "txbfit"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("nominee for Best Urban Fantasy World Building")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Filled with butt-kicking action, insidious danger, and a heroine with her own unique moral code, this thrilling story is top-notch. Brava!”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" (Top Pick!)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Gin is stronger than ever, and this series shows no signs of losing steam.”")]), _vm._v(" "), _c('p', {
    staticClass: "attb"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Fiction Vixen")])]), _vm._v(" "), _c('p', {
    staticClass: "praisea"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("SPIDER’S REVENGE")])]), _vm._v(" "), _c('p', {
    staticClass: "praisec"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("A RITA nominee and an")]), _vm._v(" "), _c('span', {
    staticClass: "txbfit"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Editor’s Choice Pick for Best Urban Fantasy Novel")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Explosive . . . outstanding. . . . Hang on, this is one smackdown you won’t want to miss!”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" (Top Pick!)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A whirlwind of tension, intrigue, and mind-blowing action that leaves your heart pounding.”")]), _vm._v(" "), _c('p', {
    staticClass: "attb"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Smexy Books")])]), _vm._v(" "), _c('p', {
    staticClass: "praisea"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("TANGLED THREADS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Interesting story lines, alluring world, and fascinating characters. That is what I’ve come to expect from Estep’s series.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Yummy Men & Kick Ass Chicks")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pag_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "pag_iii"
    }
  }, [_vm._v("“The story had me whooping with joy and screaming in outrage, just as all really good books always do.”")])]), _c('a', {
    attrs: {
      "id": "pag_iii"
    }
  }, [_c('p', {
    staticClass: "attb"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Literary Escapism")])]), _vm._v(" "), _c('p', {
    staticClass: "praisea"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("VENOM")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Estep has really hit her stride with this gritty and compelling series. . . . Brisk pacing and knife-edged danger make this an exciting page-turner.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("RT Book Reviews")]), _vm._v(" (Top Pick!)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Since the first book in the series, I have been entranced by Gin. . . . Every book has been jam-packed with action and mystery, and once I think it can’t get any better, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Venom")]), _vm._v(" comes along and proves me completely wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "attb"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Literary Escapism")])]), _vm._v(" "), _c('p', {
    staticClass: "praisea"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("WEB OF LIES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Hard-edged and compelling. . . . Gin Blanco is a fascinatingly pragmatic character, whose intricate layers are just beginning to unravel.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("RT Book Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“One of the best urban fantasy series I’ve ever read. The action is off the charts, the passion is hot, and her cast of secondary characters is stellar.”")]), _vm._v(" "), _c('p', {
    staticClass: "attb"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Romance Dish")])]), _vm._v(" "), _c('p', {
    staticClass: "praisea"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("SPIDER’S BITE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“The fast pace, clever dialogue, and intriguing heroine help make this new series launch one to watch.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Library Journal")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Bodies litter the pages of this first entry in Estep’s engrossing Elemental Assassin urban fantasy series. . . . Fans will love it.”")]), _vm._v(" "), _c('p', {
    staticClass: "attb"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Publishers Weekly")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f620084","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/praise.vue
// module id = 57
// module chunks = 0